export default __webpack_public_path__ + "7a2edae921c9e364bf62990fb24f4335.svg";